import React,{ useState } from "react";
type ContextType={searchInput:string; setInputData:()=>void;};
const SearchInputContext=React.createContext<ContextType>({
  searchInput:"",
  setInputData:()=>{},
})
export default SearchInputContext

interface SearchInputProviderProps{
  children: JSX.Element | JSX.Element[];
}

export const SearchInputProvider:React.FC<SearchInputProviderProps>=({children})=>{
  const[searchInput,setSearchInput]=useState("")
  const setInputData=(txt:string="")=>{
    setSearchInput(txt)
  }
  return <SearchInputContext.Provider value={{searchInput,setInputData}}>
    {children}
  </SearchInputContext.Provider>
}